import { Oui_TypeOuiNonNbCandidatReduitFNSSimple } from './Oui_TypeOuiNonNbCandidatReduitFNSSimple';
export class TypeOuiNonNbCandidatReduitFNSSimple {

	public oui: Oui_TypeOuiNonNbCandidatReduitFNSSimple;

	public non: string;

	constructor() {
		this.oui = new Oui_TypeOuiNonNbCandidatReduitFNSSimple();
		this.non = '';
	}
}
